import {gql} from '@apollo/client/core';
import {ProductDataFragment} from './product-data.fragment';


export const ProductPageFragment = gql`
  fragment productPage on ProductPage {
    storyblok
    product {
      ...productData
    }
  }
  ${ProductDataFragment}
`;
